<template>
  <div class="deposit-order-items" v-if="order?.orderItems?.length > 0">
    <div class="deposit-order-items-title">关联商品</div>
    <OrderItemCard
      v-for="(item, index) in order.orderItems"
      :key="index"
      :index="index"
      :data="item"
      :is-last="runInWxWork && index === order.orderItems.length - 1"
      @openImageViewer="openImageViewer"
      :currentImageIndex="item.manualUploadImagesIndex || 0"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import OrderItemCard from '../widgets/OrderItemCard.vue'

  export default {
    components: { OrderItemCard },
    props: {
      order: Object,
      isCreator: Boolean
    },
    computed: {
      ...mapGetters(['runInWxWork'])
    },
    methods: {
      openImageViewer({ orderIndex, imageIndex, images }) {
        this.$emit('openImageViewer', {
          orderIndex,
          imageIndex,
          images
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .deposit-order-items {
    padding: 20/20rem;

    &-title {
      height: 17/20rem;
      line-height: 17/20rem;
      font-size: 12/20rem;
      font-weight: 400;
      letter-spacing: 0;
      color: #5e5e5e;
    }
  }
</style>
